import { ExternalLink, MapPin } from 'lucide-react'
import type { DeliveryChoice } from '../types'

const STORE_ADDRESS = '199 Musgrave St, Berserker QLD 4701'
const MAP_QUERY = encodeURIComponent(STORE_ADDRESS)
const MAP_EMBED_URL = `https://www.google.com/maps?q=${MAP_QUERY}&output=embed`
const MAP_EXTERNAL_URL = `https://www.google.com/maps/search/?api=1&query=${MAP_QUERY}`

interface DeliveryMapProps {
  readonly selectedDelivery: DeliveryChoice | null
}

export function DeliveryMap({ selectedDelivery }: DeliveryMapProps) {
  return (
    <aside
      className="delivery-map"
      aria-labelledby="delivery-map-title"
      aria-describedby="delivery-map-disclaimer"
    >
      <div className="delivery-map__heading">
        <MapPin aria-hidden="true" />
        <div>
          <p>Illustrative Rockhampton pilot</p>
          <h3 id="delivery-map-title">Proposed local delivery map</h3>
        </div>
      </div>

      <div className="delivery-map__frame">
        <iframe
          title="Google Map centred on Sub Zero Treats at 199 Musgrave Street, Berserker"
          src={MAP_EMBED_URL}
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          allowFullScreen
        />
      </div>

      <div className="delivery-map__handoff" aria-hidden="true">
        <picture>
          <source
            media="(max-width: 700px)"
            type="image/avif"
            srcSet="/media/higgsfield/editorial/delivery-handoff-mobile-900x1125.avif"
          />
          <source
            media="(max-width: 700px)"
            srcSet="/media/higgsfield/editorial/delivery-handoff-mobile-900x1125.webp"
          />
          <source
            type="image/avif"
            srcSet="/media/higgsfield/editorial/delivery-handoff-desktop-1600x1067.avif"
          />
          <img
            className="delivery-map__handoff-image"
            src="/media/higgsfield/editorial/delivery-handoff.webp"
            alt=""
            width="1600"
            height="1067"
            loading="lazy"
            decoding="async"
          />
        </picture>
      </div>

      <div
        className="delivery-map__status"
        role={selectedDelivery ? 'status' : undefined}
        aria-live={selectedDelivery ? 'polite' : undefined}
      >
        {selectedDelivery ? (
          <>
            <span>Selected demo run</span>
            <strong>
              {selectedDelivery.day} &middot; {selectedDelivery.window}
            </strong>
            <small>{selectedDelivery.date}</small>
          </>
        ) : (
          <>
            <span>Proposed run preview</span>
            <strong>Choose a delivery day</strong>
            <small>The selected window will appear here.</small>
          </>
        )}
      </div>

      <a href={MAP_EXTERNAL_URL} target="_blank" rel="noreferrer">
        Open {STORE_ADDRESS} in Google Maps
        <ExternalLink aria-hidden="true" />
      </a>
      <p id="delivery-map-disclaimer">
        Store location shown for context. Pilot suburbs, final zones, routes,
        capacity and fees are illustrative and must be confirmed by Sub Zero
        before launch.
      </p>
    </aside>
  )
}
